var exports = {
  "t": "sortIconText__7T_D0P",
};

module.exports = exports;
